import { ENVIRONMENT } from 'utils/constants/environmentVariables';

const isProduction = ENVIRONMENT === 'production';
const isTesting = !isProduction;

export {
  isProduction,
  isTesting,
}
